import { Loading } from "@app/shared/components/Loading";
import { Button } from "@design-system/components/Button";
import { trans } from "@mongez/localization";

type LoadMorePaginationProps = {
  hasNextPage: boolean;
  isLoading?: boolean;
  onLoadMore: () => void;
};

export function LoadMorePagination({
  hasNextPage,
  isLoading,
  onLoadMore,
}: LoadMorePaginationProps) {
  if (!hasNextPage) return null;

  return (
    <div className="flex items-center gap-2">
      <Button variant="outline" onClick={onLoadMore} disabled={isLoading}>
        {isLoading ? (
          <Loading className="w-full" />
        ) : (
          trans("pagination.loadMore")
        )}
      </Button>
    </div>
  );
}
